import type { SVGProps } from "react";
export interface CarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.5 14.628a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .111.245zm1 .743a.6.6 0 0 0 .113-.245l.012-.126-.012-.126a.6.6 0 0 0-.113-.246zm-11.887-.497a.6.6 0 0 0-.113-.246v.743a.6.6 0 0 0 .113-.245L6.625 15zM5.5 14.628a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .112.245zm-2.625-3.629A.875.875 0 0 0 2 10.125a1.125 1.125 0 0 1 0-2.25 3.125 3.125 0 0 1 3.125 3.124 1.125 1.125 0 0 1-2.25 0m16 0A3.125 3.125 0 0 1 22 7.875a1.125 1.125 0 0 1 0 2.25.875.875 0 0 0-.875.874 1.125 1.125 0 0 1-2.25 0M7.625 15a1.625 1.625 0 0 1-3.242.165L4.375 15l.008-.165A1.625 1.625 0 0 1 6 13.375l.166.008c.82.083 1.459.776 1.459 1.617m12 0a1.625 1.625 0 0 1-3.242.165L16.375 15l.008-.165A1.625 1.625 0 0 1 18 13.375l.166.008c.82.083 1.459.776 1.459 1.617"
      />
      <path
        fill={color}
        d="M20.875 15A2.87 2.87 0 0 0 18 12.125H6A2.87 2.87 0 0 0 3.125 15v2.875h17.75zM8.262 5.124c-.784 0-1.48.488-1.753 1.211l-.049.148-.977 3.42q.255-.028.517-.029h12q.261.001.516.028l-.975-3.419a1.875 1.875 0 0 0-1.804-1.359zM23.125 21a1.125 1.125 0 0 1-2.25 0v-.875H3.125V21a1.125 1.125 0 0 1-2.25 0v-6c0-1.639.77-3.097 1.964-4.033l1.458-5.1.107-.326a4.13 4.13 0 0 1 3.858-2.666h7.475a4.125 4.125 0 0 1 3.967 2.991l1.377 4.825.078.276a5.12 5.12 0 0 1 1.966 4.032v6Z"
      />
    </svg>
  );
}
